const getCsrfToken = () => {
  return document.querySelector('meta[name="csrf-token"]').getAttribute('content');
}

const handleBookmark = async (el) => {
  const positionId = el.dataset.bookmarkPositionId;
  const response = await fetch('/direct/bookmarks', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': getCsrfToken()
    },
    body: JSON.stringify({ position_id: positionId }),
  });
  if (!response.ok) throw new Error();
  updateBookmarkButton(positionId, true);
}

const handleUnbookmark = async (el) => {
  const positionId = el.dataset.bookmarkPositionId;
  const response = await fetch('/direct/bookmark', {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': getCsrfToken()
    },
    body: JSON.stringify({ position_id: positionId }),
  })
  if (!response.ok) throw new Error();
  updateBookmarkButton(positionId, false);
}

const updateBookmarkButton = (positionId, isBookmarked) => {
  const elements = document.querySelectorAll(`[data-bookmark-position-id='${positionId}']`);
  elements.forEach(el => {
    if (isBookmarked) {
      el.classList.add('bookmarked');
      el.textContent = 'リストに保存済';
    } else {
      el.classList.remove('bookmarked');
      el.textContent = 'この求人を保存';
    }
  })
}

const postEopClickEvent = (el, bookmarked) => {
  if (!window.eop) return;

  const jobId = el.dataset.bookmarkPositionId;
  const companyId = el.dataset.companyId;

  const eopEvent = Object.assign({}, window.eop.getEnvironment(), {
    source: "web",
    action: "click",
    contents: "bookmark",
    split: "default",
    job_id: jobId,
    company_id: companyId,
    type: bookmarked ? 'bookmark' : 'delete'
  });
  window.eop.postEvent([eopEvent], true);
}

export function registerPositionBookmarkHandler() {
  /*
    * .m3p-joblist 求人一覧
    * .m3p-joboffer__btn 求人カードの求人保存ボタン
    * .m3p-bookmark-detail__button-container 求人詳細の求人保存ボタンの親要素
  */
  const TARGET_ELEMENT_SELECTORS = '.m3p-joblist, .m3p-joboffer__btn, .m3p-container__detail';
  const ON_LOADING_CLASS = 'is-loading';
  const area = document.querySelector(TARGET_ELEMENT_SELECTORS);
  if (!area) return;

  area.addEventListener('click', async (e) => {
    const button = e.target;
    const positionId = button.dataset.bookmarkPositionId;

    // positionIdがない、ローディング中は何もしない
    if (!positionId || button.classList.contains(ON_LOADING_CLASS)) return;
    e.preventDefault();
    button.classList.add(ON_LOADING_CLASS);
    const shouldBookmark = !button.classList.contains('bookmarked');

    try {
      if (shouldBookmark) {
        await handleBookmark(button);
      } else {
        await handleUnbookmark(button);
      }
    } catch(e) {
      console.error(e);
      alert('求人票の保存に失敗しました。もう一度お試しください。');
    } finally {
      button.classList.remove(ON_LOADING_CLASS);
    }
    // eop送信
    postEopClickEvent(button, shouldBookmark);
  });
}
